module.exports = __webpack_public_path__ + "media/common/images/innogy_style/work-environment-461756b5b0783f40a6cdce64b43056e8.svg";